import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPoolingMetrics, fetchVesselDetailsTable,deleteVesselwithTokenId } from "../../features/VesselDetails/VesselDetailsSlice";
import { ConfigProvider, Button, notification, Modal } from "antd";
import enUS from "antd/lib/locale/en_US";
import { FaSearch } from "react-icons/fa";
import vesselShip from "../../assets/icons/VesselDetails/vessel.svg";
import surplus from "../../assets/icons/VesselDetails/surplus.svg";
import deficit from "../../assets/icons/VesselDetails/deficit.svg";
import filterIcon from "../../assets/icons/VesselDetails/filter.svg";
import VesselDetailsTable from "./VesselDetailsTable";
import VesselDetailFilter from "./VesselDetailFilter"; 
import dayjs from "dayjs";
import { getVesselDetailsFilterList } from "../../features/VesselDetails/VesselDetailsSlice";


const addThousandSeparator = (value) => {
  // Ensure the value is a valid number
  const number = parseFloat(value);

  if (isNaN(number)) {
    return ''; // Return an empty string for invalid input
  }

  // Format the number with thousand separators
  return number.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 20, // Adjust to retain maximum precision if needed
  });
};

const VesselDetailshead = () => {
  const [activeButton, setActiveButton] = useState("My Vessels");
  const [requestedVesselType, setRequestedVesselType] = useState("my_vessels");
  const [searchQuery, setSearchQuery] = useState("");
  const [vesselDetailFilterModal, setVesselDetailFilterModal] = useState(false);
  const [deleteConfirmationModal,setDeleteConfirmationModal] = useState(false);
  const [vesselTokenIdSelectedToDelete,setVesselTokenIdSelectedToDelete] = useState(null);

  const dispatch = useDispatch();
  const { metrics, loading, error, vesselDetailsTableData } = useSelector(
    (state) => state.vesselDetails
  );

  const buttons = [
    { label: `My Vessels [${metrics?.cb_my_vessels_count || 0}]`, type: "my_vessels", count: metrics?.cb_my_vessels_count || 0 },
    { label: `All Vessel [${metrics?.total_vessels_count || 0}]`, type: "", count: metrics?.total_vessels_count || 0 },
    { label: `Deficit [${metrics?.cb_deficit_vessels_count || 0}]`, type: "deficit", count: metrics?.cb_deficit_vessels_count || 0 },
    { label: `Surplus [${metrics?.cb_surplus_vessels_count || 0}]`, type: "surplus", count: metrics?.cb_surplus_vessels_count || 0 },
  ];

  const { tableDataUpdated } = useSelector((state) => state.pooling);
  const [selectedYear, setSelectedYear] = useState(dayjs().startOf('year').year());
  const [filterValues, setFilterValues] = useState({
    year: "",
    complianceBalance: "",
    ghg: "",
    penalty: "",
    shipOwner: "",
    pic: "",
  });

  const handleApplyFilter = (values) => {
    setFilterValues(values);

    const { year, complianceBalance, ghg, penalty, shipOwner, pic } = values;
    console.log("year, complianceBalance, ghg, penalty",year, complianceBalance, ghg, penalty)
    if (year) {
      setSelectedYear(year);
    }


    // Apply filters based on the values received from the modal
    const filterParams = {
      year: year ? year : "",
      compliance_balance_min: parseFloat(complianceBalance[0]),  // Handle compliance balance minimum
      compliance_balance_max: parseFloat(complianceBalance[1]),  // Handle compliance balance maximum
      ghg_min: parseFloat(ghg[0]),  // Handle ghg minimum
      ghg_max: parseFloat(ghg[1]),  // Handle ghg maximum
      penalty_min: parseFloat(penalty[0]),  // Handle penalty minimum
      penalty_max: parseFloat(penalty[1]),
      requested_vessel_type: requestedVesselType,
      ship_owner: shipOwner,
      pic_name: pic,
    };
    console.log("compliance_balance",complianceBalance)

    // Fetch updated data based on filters
    dispatch(fetchPoolingMetrics(filterParams));
    dispatch(fetchVesselDetailsTable(filterParams));

    setVesselDetailFilterModal(false); // Close the modal
  };

  useEffect(()=>{
    dispatch(getVesselDetailsFilterList());

  },[]);

  const filteredVesselDetailsTableData = vesselDetailsTableData?.filter((vessel) => {
    const isSearchQueryValid = searchQuery && searchQuery.trim() !== "";
  
    // Check if the search query matches the token ID or vessel name
    const isSearchMatch = isSearchQueryValid
      ? vessel?.token_id.toLowerCase().includes(searchQuery.toLowerCase()) ||
        vessel?.vessel_name.toLowerCase().includes(searchQuery.toLowerCase())
      : true;
  
    // If no year range is selected, just apply the search query filter
    return isSearchMatch;
  });
  
  
  
  
  useEffect(() => {
  
    const filterParams = {
      ...(filterValues?.year && { year: filterValues.year }),
      compliance_balance_min: parseFloat(filterValues.complianceBalance[0]),  // Handle compliance balance minimum
      compliance_balance_max: parseFloat(filterValues.complianceBalance[1]),  // Handle compliance balance maximum
      ghg_min: parseFloat(filterValues.ghg[0]),  // Handle ghg minimum
      ghg_max: parseFloat(filterValues.ghg[1]),  // Handle ghg maximum
      penalty_min: parseFloat(filterValues.penalty[0]),  // Handle penalty minimum
      penalty_max: parseFloat(filterValues.penalty[1]),
      ship_owner: filterValues.shipOwner,
      pic_name: filterValues.pic,
      requested_vessel_type: requestedVesselType,
    };
  
    // Dispatch to fetch the updated pooling metrics with all filters

    const requested_vessel_type = buttons.find((btn) => btn.label.startsWith(activeButton))?.type || "";
    
    setRequestedVesselType(requested_vessel_type);

    dispatch(fetchPoolingMetrics(filterParams));
    dispatch(fetchVesselDetailsTable(filterParams));
  
  }, [dispatch, activeButton, tableDataUpdated]); // Added filterValues as a dependency

  const handledeleteModalVisbility = (token_id) => {
    setDeleteConfirmationModal(true);
    setVesselTokenIdSelectedToDelete(token_id);
  }

  const onCancel = () => {
    setDeleteConfirmationModal(false);
    setVesselTokenIdSelectedToDelete(null);


  }

  const handleDelete = async () => {
    const response = await dispatch(deleteVesselwithTokenId({ token_id: vesselTokenIdSelectedToDelete }));
    if (response.meta.requestStatus === 'fulfilled') {
      setDeleteConfirmationModal(false);

      notification.success({
        message: "Pool Deleted Successfully",
        description: `Vessel with TOKEN ID - ${vesselTokenIdSelectedToDelete} has been deleted successfully.`,
        placement: "topRight", 
      });

      const filterParams = {
        ...(filterValues?.year && { year: filterValues.year }),
        compliance_balance_min: parseFloat(filterValues.complianceBalance[0]),  // Handle compliance balance minimum
        compliance_balance_max: parseFloat(filterValues.complianceBalance[1]),  // Handle compliance balance maximum
        ghg_min: parseFloat(filterValues.ghg[0]),  // Handle ghg minimum
        ghg_max: parseFloat(filterValues.ghg[1]),  // Handle ghg maximum
        penalty_min: parseFloat(filterValues.penalty[0]),  // Handle penalty minimum
        penalty_max: parseFloat(filterValues.penalty[1]),
        requested_vessel_type: requestedVesselType,
      };

      await dispatch(fetchPoolingMetrics(filterParams));
      await dispatch(fetchVesselDetailsTable(filterParams));
      
    } else {
      setDeleteConfirmationModal(false);

      notification.error({
        message: "Deletion Failed",
        description: "There was an error deleting the pool. Please try again.",
        placement: "topRight",
      });
      console.error("Error deleting pool:", response.error.message);
    }
  };
  

  const vesselDetailsData = [
    {
      color: "#678DFF14",
      icon: vesselShip,
      heading: "Total",
      subheading: "Vessel",
      number: metrics?.total_vessels_count != "" ? metrics?.total_vessels_count : "0",
      numberColor: "#678DFF",
    },
    {
      color: "#0CC87614",
      icon: surplus,
      heading: "Total",
      subheading: "C.B. Surplus",
      number: 
        metrics?.cb_surplus !== undefined
          ? (
              <div style={{textAlign:"center"}}>
                {addThousandSeparator((Math.floor(Number(metrics?.cb_surplus) * 1000000) / 1000000).toFixed(6))} <br/> (MT CO<sub>2</sub>e)
              </div>
            )
          : "Loading...",
      numberColor: "#0CC876",
    },
    {
      color: "#FB2F2F0A",
      icon: deficit,
      heading: "Total",
      subheading: "C.B. Deficit",
      number: metrics?.cb_deficit !== undefined
        ? (
            <div style={{textAlign:"center"}}>
              {addThousandSeparator((Math.floor(Number(metrics?.cb_deficit) * 1000000) / 1000000).toFixed(6))} <br/> (MT CO<sub>2</sub>e)
            </div>
          )
        : "Loading...",
      numberColor: "#FB2F2F",
    },    
  ];

  return (
    <ConfigProvider locale={enUS}>
      <div className="vessel-detail-page">
        <div className="vesselDetails-container">
          {vesselDetailsData.map((item, index) => (
            <div
              key={index}
              className="vesselDetails-card"
              style={{ backgroundColor: item.color }}
            >
              <img
                src={item.icon}
                alt={`${item.heading}-icon`}
                className="vesselDetails-icon"
              />
              <div className="vesselDetails-info">
                <h3 className="vesselDetails-heading">{item.heading}</h3>
                <p className="vesselDetails-subheading">{item.subheading}</p>
              </div>
              <span
                className="vesselDetails-number"
                style={{ color: item.numberColor }}
              >
                {item.number}
              </span>
            </div>
          ))}
        </div>

        <div className="vesselDetails-buttons">
          {buttons.map(({ label, count, type }) => (
            <div
              key={label}
              className={`vesselDetails-button ${label.toLowerCase().includes(activeButton.toLowerCase()) ? "active" : ""} ${activeButton != label && type === "deficit" ? "deficit" : activeButton != label && type === "surplus" ? "surplus" : ""}`}
              onClick={() => {
                console.log("label",label,label.includes(activeButton))
                setActiveButton(label);
                setRequestedVesselType(type);
              }}
            >
              {label} {/* Button with dynamic count */}
            </div>
          ))}

          <div className="vesselDetails-actions">
            <div className="vesselDetails-search-container">
              <FaSearch className="search-icon" style={{ color: "#A4A4A4" }} />
              <input
                type="text"
                placeholder="Search by Token ID or Vessel Name"
                className="vesselDetails-search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            <Button className="vesselDetails-filter" onClick={() => setVesselDetailFilterModal(true)}>
              <span className="vesselDetails-filter-text">Filter</span>
              <img src={filterIcon} alt="Filter" className="filter-icon" />
            </Button>
          </div>
        </div>

        {loading && <div>Loading Data...</div>}
        {error && <div>Error: {error}</div>}
        {metrics && filteredVesselDetailsTableData && (
          <VesselDetailsTable
            vesselDetailsTableData={filteredVesselDetailsTableData}
            metrics={metrics}
            activeButton={activeButton}
            handledeleteModalVisbility={handledeleteModalVisbility}
            requestedVesselType={requestedVesselType}
          />
        )}

        {/* Filter Modal */}
        
        <VesselDetailFilter
          visible={vesselDetailFilterModal}
          onCancel={() => setVesselDetailFilterModal(false)} // Close modal
          onApply={handleApplyFilter} 
        />

      {deleteConfirmationModal && 
        <Modal
        title="Confirm Deletion"
        visible={deleteConfirmationModal}
        onOk={handleDelete}
        onCancel={onCancel}
        okText="Delete"
        cancelText="Cancel"
      >
        <p>Are you sure you want to delete this Vessel with Token ID: {vesselTokenIdSelectedToDelete}?</p>
      </Modal>
      }

      </div>
    </ConfigProvider>
  );
};

export default VesselDetailshead;
